import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { DisclaimerStyle, DisclaimerText } from '../styles';
import { useSlideData } from '@context/slide-data';
import { getProfile } from '@utils/profileUtils';

export const Disclaimer = ({ name }) => {
    const { t } = useTranslation();
    const { firm } = useClient();
    const { desktop } = useSlideData();

    const isIntro = name === 'Introduction';

    return (
        <DisclaimerStyle desktop={desktop} intro={isIntro} >
            {
                isIntro ? (
                    <DisclaimerText color='#fff' width='90%'>
                        **{t('disclaimer.intro_1')}
                        <span>{firm}</span>
                        {t('disclaimer.intro_2')}**
                    </DisclaimerText>
                ) : (
                    <DisclaimerText>
                        **{t('disclaimer.standard_1')}
                        <span>{firm}</span>
                        {t('disclaimer.standard_2')}
                        <span>{getProfile(firm)}.**</span>
                    </DisclaimerText>
                )
            }
        </DisclaimerStyle>
    );
};

export default Disclaimer;
